import { useState } from 'react';
import { Link } from 'react-router';
import { useForgotPassword } from '../auth/session';
import { AuthLayout } from './AuthLayout';
import { Banner, Button, Field, TextInput } from '../components/ui';

export function ForgotPasswordPage() {
  const forgot = useForgotPassword();
  const [email, setEmail] = useState('');

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We will email you a link if that address has a confirmed account."
      footer={
        <Link to="/login" className="text-accent hover:underline">
          Back to sign in
        </Link>
      }
    >
      {forgot.isSuccess ? (
        // Deliberately vague: the API does not reveal whether the address exists, and neither
        // should the page.
        <Banner tone="success">
          If that address needs action, a reset link is on its way.
        </Banner>
      ) : (
        <form
          className="flex flex-col gap-4"
          onSubmit={(event) => {
            event.preventDefault();
            forgot.mutate({ email });
          }}
        >
          <Field label="Email">
            {(id, describedBy) => (
              <TextInput
                id={id}
                aria-describedby={describedBy}
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            )}
          </Field>

          <Button type="submit" variant="primary" disabled={forgot.isPending}>
            {forgot.isPending ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
